import SegmentSection from './SegmentSection';

export default SegmentSection;
